import { Component, Input } from '@angular/core';

@Component({
  selector: 'insights-card',
  templateUrl: './insights-card.component.html',
  styleUrl: './insights-card.component.scss'
})
export class InsightsCardComponent {
  @Input() title = '';
  @Input() body = '';
}
